module.exports = __webpack_public_path__ + "fonts/oswald-bold.8175fd72.ttf";